export default __webpack_public_path__ + "static/media/Folk.dfa391b5.mp3";